import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { PAGE_SIZE } from '@/app/(plp)/constants';
import { cn } from '@/utils/cn';
interface Props {
  count?: number;
  isInfiniteLoading?: boolean;
}
const PLPGridSkeleton = ({
  count = PAGE_SIZE
}: Props) => {
  const {
    isMobile
  } = useMobileDetect();
  return <div className='grid grid-cols-2 lg:grid-cols-4' data-sentry-component="PLPGridSkeleton" data-sentry-source-file="plp-grid-skeleton.tsx">
            {Array(count).fill(null).map((_, i) => <div className={cn('flex flex-col', 'border-b border-border-gray-light py-3.5 lg:py-5 [&:not(:nth-child(2n))]:border-l lg:[&:not(:nth-child(4n))]:border-l', {
      'odd:pl-3.5 even:pr-3.5': isMobile,
      'pl-5 pr-5 odd:pl-5 even:pr-5 [&:nth-child(4n)]:pl-0 [&:nth-child(4n+1)]:pr-0': !isMobile
    })} key={i}>
                        <div className='mx-auto mb-1 h-35 w-35 animate-pulse rounded bg-gray-100 lg:h-39 lg:w-39' />

                        <div className='mb-0.5 h-5 w-full animate-pulse rounded bg-gray-100 lg:h-6' />
                        <div className='mb-0.5 h-10 w-full animate-pulse rounded bg-gray-100 lg:h-12' />
                        <div className='mb-2 h-4 w-full animate-pulse rounded bg-gray-100 lg:h-5' />

                        <div className='h-10 w-full animate-pulse rounded bg-gray-100 lg:mr-auto lg:h-12 lg:w-3/4' />
                    </div>)}
        </div>;
};
export default PLPGridSkeleton;